/**
 * Application version information
 * This file is automatically updated during the build process
 */

// Current application version - incremented with each build
export const VERSION = '1.0.5';

// Build timestamp
export const BUILD_TIMESTAMP = new Date('2025-04-21T11:58:44.578Z');

// Build ID - unique identifier for this build
export const BUILD_ID = '3d8c0ceac3ec26c1c51dbd74227deb6fa4ef783e';

export default {
  VERSION,
  BUILD_TIMESTAMP,
  BUILD_ID
};
